<!--
*** Using the default loader and error ***
<LoaderFromUri v-slot="page" :uri="uri">
  <DebugDump :value="page" />
</LoaderFromUri>


*** Using custom loader ***
<LoaderFromUri :uri="uri">
  <template #loading>
    loading...
  </template>
  <template #default="page">
    <DebugDump :value="page" />
  </template>
</OrganismLoaderUri>
-->

<template>
  <div>
    <slot v-if="state === 'loading'" name="loading"><AtomAnimationsCircleLoader class="w-12 h-12" /></slot>
    <slot v-if="state === 'error'" name="error" />
    <slot v-if="state === 'ready'" v-bind="page" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  uri: { type: String, required: true },
})

const emit = defineEmits(['loaded', 'error'])

const pageStore = usePageStore()

const { data: page, status, error } = await useAsyncData(`loader-from-uri;${props.uri}`, () => pageStore.fetchUri({ uri: props.uri }))

/*
 * Derive the render state from useAsyncData rather than assigning to a ref inside the handler: only the
 * returned data reaches the payload, and the handler does not run again on the client, so such a ref keeps
 * its initial value after hydration and the server and client render different slots.
 */
const state = computed(() => {
  if (status.value === 'pending') {
    return 'loading'
  }

  return error.value || !page.value ? 'error' : 'ready'
})

// Immediate so consumers are notified during SSR as well, matching where the emits used to sit.
watch(
  state,
  (value) => {
    if (value === 'ready') {
      emit('loaded', { uri: props.uri, page: page.value })
    } else if (value === 'error') {
      emit('error', { uri: props.uri, error: error.value })
    }
  },
  { immediate: true },
)
</script>
